"use client"

import { Minus, Plus, ShoppingBag } from "lucide-react"
import { useState } from "react"

import { Button } from "@/components/ui/button"

export function CommerceControlsIsland({ variants = ["Standard", "Premium"] }: { variants?: string[] }) {
  const [quantity, setQuantity] = useState(1)
  const [variant, setVariant] = useState(variants[0] ?? "Default")

  return (
    <div className="grid gap-4 rounded-panel border border-border/70 bg-card p-5 shadow-sm">
      <div className="flex flex-wrap gap-2" role="group" aria-label="Product variant">
        {variants.map((item) => (
          <button key={item} type="button" onClick={() => setVariant(item)} className={`rounded-full border px-4 py-2 text-sm font-semibold transition-colors ${variant === item ? "border-primary bg-primary text-primary-foreground" : "border-border bg-background text-muted-foreground hover:text-foreground"}`}>
            {item}
          </button>
        ))}
      </div>
      <div className="flex items-center justify-between gap-4">
        <div className="inline-flex items-center rounded-full border border-border/70 bg-background p-1">
          <Button type="button" size="icon" variant="ghost" className="rounded-full" onClick={() => setQuantity((value) => Math.max(1, value - 1))} aria-label="Decrease quantity"><Minus className="size-4" /></Button>
          <span className="w-10 text-center text-sm font-semibold">{quantity}</span>
          <Button type="button" size="icon" variant="ghost" className="rounded-full" onClick={() => setQuantity((value) => value + 1)} aria-label="Increase quantity"><Plus className="size-4" /></Button>
        </div>
        <Button type="button" className="rounded-full"><ShoppingBag className="size-4" /> Add to cart</Button>
      </div>
    </div>
  )
}